/**
 * Vehicle emissions unit CO2 values
 */
export enum VehicleEmissionsUnitCO2Enum {
	GRAMS_KM = 'grams-km',
	GRAMS_MI = 'grams-mi',
}
